import React from 'react'
import * as TwoStepPaymentForm from '../../../../common/components/entities/TwoStepPaymentForm'
import useFlutterwavePaymentHandler from '../../../hooks/payment/useFlutterwavePaymentHandler'
import useManagement, {
  selectors as managementSelectors,
} from '../../../hooks/useManagement'
import FieldErrors from '../../FieldErrors'
import { TwoStepPaymentButtonProps } from './TwoStepPaymentButtonProps'

export default function TwoStepFlutterwavePaymentButton({
  entity,
  styles,
  mobileStyles,
}: TwoStepPaymentButtonProps) {
  const { isLoading, handleSubmit, errors } =
    useFlutterwavePaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <TwoStepPaymentForm.Button
        onClick={handleSubmit}
        styles={styles}
        mobileStyles={mobileStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
        disabled={isLoading || isPreview}
      />
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
